import { Flex, Text } from "@chakra-ui/react";

interface ViewInformationBlockProps {
    children: React.ReactNode;
    icon: React.ReactNode;
    title: string;
}

export const ViewInformationBlock = ({ children, icon, title }: ViewInformationBlockProps) => {
    return (
        <Flex
            padding="24px"
            border="1px solid #e1e7ef"
            borderRadius="8px"
            bg="white"
            flexDirection="column"
            gap="24px"
            w="100%"
        >
            <Flex alignItems="center" gap="8px">
                {icon}
                <Text fontSize={24} fontWeight={600} color="#3b515e">{title}</Text>
            </Flex>
            {children}
        </Flex>
    )
}